import React, { useState, useEffect } from 'react';
import { MC_STYLES } from '../constants/mcStyles.js';
import './McQuestion.css';

export default function McQuestion({ question, answered, onSubmit }) {
  const [picked, setPicked] = useState(null);
  const { payload, revealed } = question;

  useEffect(() => {
    setPicked(null);
  }, [question.id]);

  const pick = (index) => {
    if (answered || revealed) return;
    setPicked(index);
    onSubmit({ choiceIndex: index });
  };

  return (
    <div className="card stack mc-question">
      <div className="row-between">
        <span className="q-kicker">คำถามปรนัย</span>
      </div>
      <h2>{payload.question}</h2>
      {payload.code && <pre className="q-code">{payload.code}</pre>}

      <div className="mc-grid">
        {payload.options.map((text, i) => {
          const style = MC_STYLES[i % MC_STYLES.length];
          const isPicked = picked === i;
          const isCorrectOption = revealed && payload.correctIndex === i;
          const isWrongPick = revealed && isPicked && payload.correctIndex !== i;
          return (
            <button
              key={i}
              type="button"
              className={`mc-option ${isPicked ? 'is-picked' : ''} ${isCorrectOption ? 'is-correct' : ''} ${isWrongPick ? 'is-wrong' : ''}`}
              style={{ '--option-color': `var(${style.colorVar})` }}
              disabled={answered || revealed}
              onClick={() => pick(i)}
            >
              <span className="mc-shape" aria-hidden="true">{style.shape}</span>
              <span className="mc-text">{text}</span>
            </button>
          );
        })}
      </div>

      {answered && !revealed && <p className="text-dim text-center">ส่งคำตอบแล้ว รอผลการเฉลย...</p>}
    </div>
  );
}
